import { useEffect, useState } from "react";
import { getImageDataForEncoding } from "utils/blurhashhelpers";
import EncodeWorker from "../../encode.worker";

type Props = string | undefined;

export default function useBlurHashEncoder(fileURL: Props) {
  const [imageHash, setImageHash] = useState<string | undefined>();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!fileURL) {
      return;
    }
    let worker: Worker;

    async function generateAndSetBlurHash() {
      setLoading(true);
      // @ts-ignore
      worker = new EncodeWorker();

      worker.addEventListener("message", (e: MessageEvent<{ hash: string }>) => {
        const { hash } = e.data;
        setImageHash(hash);
        setLoading(false);
      });

      worker.addEventListener("error", (e) => {
        console.error(e);
        setLoading(false);
      });

      const [data, width, height, componentX, componentY] = await getImageDataForEncoding(fileURL as string);
      worker.postMessage({
        payload: { data, width, height, componentX, componentY },
      });
    }

    generateAndSetBlurHash();

    // eslint-disable-next-line consistent-return
    return () => {
      if (worker) {
        worker.terminate();
      }
    };
  }, [fileURL]);

  if (!fileURL) return [undefined, false];

  return [imageHash, isLoading] as const;
}
